/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from "react-tooltip";
import '../css/styles.css';
import is from 'is_js'

class HelpInfo extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            toggleView: false,
        }
    }

    render() {
        return(
            <div className="helpInfo">
                <label><b>{this.props.labelText} – {this.props.helpInfoText}</b></label>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        language: state.language.language,
        strings: state.language.strings,
    }
}
const ConnectedHelpInfo = connect(
    mapStateToProps,
)(HelpInfo);
export default ConnectedHelpInfo;